import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/use-auth";

export default function HomePage() {
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();
    
    useEffect(() => {
        // Redirect to dashboard if logged in, otherwise to login
        if (isLoggedIn()) {
            navigate("/dashboard");
        } else {
            navigate("/login");
        }
    }, [isLoggedIn, navigate]);
    
    // Return empty while redirecting
    return null;
}